// All fetches to the api should have some default headers (csrf token, user language, content type)
const baseUrl = "/api";
const defaultHeaders: Record<string, string> = {
  "Content-Type": "application/json",
};

export function setApiFetchDefaultHeader(key: string, value: string): void {
  defaultHeaders[key] = value;
}

export function apiFetch(
  path: string,
  options: RequestInit = {},
): Promise<Response> {
  // should only be used in front end to call internal api endpoints
  if (typeof window === "undefined") {
    throw new Error(
      "apiFetch should only be used in front end to call internal api endpoints",
    );
  }
  return fetch(`${baseUrl}${path}`, {
    ...options,
    headers: { ...defaultHeaders, ...options.headers },
  });
}
